import { render, staticRenderFns } from "./AddReseller.vue?vue&type=template&id=cdd1c57a&scoped=true&"
import script from "./AddReseller.vue?vue&type=script&lang=js&"
export * from "./AddReseller.vue?vue&type=script&lang=js&"
import style0 from "./AddReseller.vue?vue&type=style&index=0&id=cdd1c57a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd1c57a",
  null
  
)

component.options.__file = "AddReseller.vue"
export default component.exports